let sid = ''

export const setSid = (s) => {
  sid = s
}

export const getSid = () => {
  return sid
}
